export default __webpack_public_path__ + "static/media/logo-360ty.f7efacc0.png";